import { routerHelpers } from '@approvalmax/utils';
import { type Updater, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { getQueryKey } from '../helpers/getQueryKey';
import { RequestParams } from '../types';

export const useOptimisticUpdate = <Query extends { response: Record<string, any>; params?: RequestParams } = never>(
    path: string
) => {
    const queryClient = useQueryClient();

    return useCallback(
        (
            updater: Updater<Query['response'] | undefined, Query['response'] | undefined>,
            requestParams: Query['params']
        ) => {
            const url = routerHelpers.testPathByParams(path, requestParams?.path)
                ? routerHelpers.pathToUrl(path, requestParams?.path)
                : '';

            queryClient.setQueryData(getQueryKey(url, requestParams?.query), updater);
        },
        [queryClient, path]
    );
};
